// extracted by mini-css-extract-plugin
export default {"privacy":"BalloonPrivacy_privacy__YIaA0","listLink":"BalloonPrivacy_listLink__PM773"};